import React from 'react';
import { loaderAnimation } from '../../../Api';
import {getTopicSummary} from '../../../utilityFunctions/WellnessUtil';
import {Box} from "@mui/material";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";

/**
 * LlmChoose Component
 * 
 * A routing component that fetches topic summary data and redirects the user
 * to the appropriate view based on whether topic data is available or not.
 * Displays a loading animation while processing.
 * 
 * @param {Object} props - Component props including loginUser data
 * @returns {JSX.Element} - A loading animation while processing the redirection
 */
export default function LlmChoose(props) {

    const{loginUser} = props;
    const history = useHistory();

    /**
     * Effect hook that runs on component mount to initialize the component
     * by fetching data and determining where to redirect the user.
     */
    React.useEffect(() => {
        const init = async () => {
            await initialValues();
        }
        init();
    }, []);

    /**
     * Fetches topic summary data and redirects to appropriate view
     * based on API response.
     * 
     * If no data is found, redirects to the form system.
     * If data is found, redirects to the AI Grace interface with the topic data.
     * 
     * @returns {Promise<void>}
     */
    const initialValues = async () => {

        const topicId = props?.location?.state?.topicId || 124;
        // const topicId = props?.location?.state?.topicId || 49372; //Test env
        
        const response = await getTopicSummary({topicId: topicId}, loginUser.jwtToken);

        if(!response){
            history.push({
                pathname: "/retirement_plan/grace_form",
                state: {
                    topicId: topicId,
                    reference: "form_system_initial",
                    selectedTopicIndex: props?.location?.state?.selectedTopicIndex || 0
                }
            });
            return;
        };

        history.push({
            pathname: "/consumer/ai-grace",
            state:{
                reference: "grace_system_initial",
                topicSummary: response,
                topicId: topicId,
                selectedTopicIndex: props?.location?.state?.selectedTopicIndex || 0
            }
        });
        return;
    };

    /**
     * Renders a loading animation centered on the screen
     * while data is being fetched and redirection is processed.
     */
    return (
        <Box sx={{display: "flex", justifyContent: "center", width: "100%", height: "100%"}}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "95%",
                    height: "90%",
                    textAlign: "center",
                    marginTop: {xs: "1.3rem", sm: 0},
                }}
            >
                {loaderAnimation}
            </Box>
        </Box>
    )
}
